// extracted by mini-css-extract-plugin
export default {"container":"Warning_container__UJkjI"};